import { render, staticRenderFns } from "./top-products-by-units-sold.vue?vue&type=template&id=3c71e6f0"
import script from "./top-products-by-units-sold.vue?vue&type=script&lang=js"
export * from "./top-products-by-units-sold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports